const TRUMP_MAP: Record<string, { symbol: string; color: string }> = {
  spades: { symbol: "\u2660", color: "text-gray-900" },
  clubs: { symbol: "\u2663", color: "text-gray-900" },
  hearts: { symbol: "\u2665", color: "text-red-600" },
  diamonds: { symbol: "\u2666", color: "text-red-600" },
  sans_atout: { symbol: "SA", color: "text-gray-500" },
  tout_atout: { symbol: "TA", color: "text-gray-500" },
};

export function TrumpBadge({
  trump,
  className = "",
}: {
  trump: string;
  className?: string;
}) {
  const entry = TRUMP_MAP[trump] ?? { symbol: trump, color: "text-gray-500" };
  return <span className={`${entry.color} ${className}`}>{entry.symbol}</span>;
}
